module.exports = __webpack_public_path__ + "media/images/icons/banda_invitada_form-ee2fa62b48e21eb04670ccf9234fb5f4.svg";